/**
 * Scripts for Frontend Website
 */
 
$(document).ready(function() {

	//console.log("Frontend Website");

  $(window).scrollTop($(window).scrollTop()+1);

	// fix height carousel image
	$('.carousel-inner>.item').css('max-height', $(window).height());

  //
  // Custom navBar
  //

  $("#sidebar").mCustomScrollbar({
      theme: "minimal"
  });

  // when opening the sidebar
  $('#sidebarCollapse').on('click', function (event) {
      event.preventDefault();
      // open sidebar
      $('#sidebar').addClass('active');
      // fade in the overlay
      $('.overlay').fadeIn();
      $('.collapse.in').toggleClass('in');
      $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  });

  // if dismiss or overlay was clicked
  // mobile
  $('.overlay').on('click', function () {
    // hide the sidebar
    $('#sidebar').removeClass('active');
    // fade out the overlay
    $('.overlay').fadeOut();
  });

  // navigation click actions  
  $('.scroll-link').on('click', function(event){
   event.preventDefault();
   var sectionID = $(this).attr("data-id");
   scrollToID('#' + sectionID, 750);
  });
  // scroll to top action
  $('.scroll-top').on('click', function(event) {
   event.preventDefault();
   $('html, body').animate({scrollTop:0}, 'slow');     
  });
  // mobile nav toggle
  $('#nav-toggle').on('click', function (event) {
   event.preventDefault();
   $('#main-nav').toggleClass("open");
  });
  
  

  // scroll function
  function scrollToID(id, speed){
    var offSet = 200;
    var targetOffset = $(id).offset().top - offSet;
    var mainNav = $('#main-nav');
    $('html,body').animate({scrollTop:targetOffset}, speed);
    if (mainNav.hasClass("open")) {
      mainNav.css("height", "1px").removeClass("in").addClass("collapse");
      mainNav.removeClass("open");
    }
  }

  //
  // END Custom navBar
  //

   $(".filter-button").click(function(){
          var value = $(this).attr('data-filter');
          
          if(value == "all")
          {
              //$('.filter').removeClass('hidden');
              $('.filter').show('1000');
          }
          else
          {
              //            $('.filter[filter-item="'+value+'"]').removeClass('hidden');
              //            $(".filter").not('.filter[filter-item="'+value+'"]').addClass('hidden');
              $(".filter").not('.'+value).hide('3000');
              $('.filter').filter('.'+value).show('3000');
              
          }
      });

   //
   // button iwann
   //
    $(".iwanna").click(function(){
      var reference = $(this).attr('data-reference');
      document.getElementById('reference_tech_modal').innerHTML = '';
      document.getElementById('reference_tech_modal').innerHTML = reference;
    });

   //
   // event for lightBox
   //
   $(document).on('click', '[data-toggle="lightbox"]', function(event) {
       event.preventDefault();
       $(this).ekkoLightbox();
   });

   // right redirect for buttons
   if(window.location.href.indexOf('goto_contact') > 0){
     document.getElementById('contact_div').click();
   }else if(window.location.href.indexOf('goto_who') > 0){
     document.getElementById('who_div').click();
   }

   if(window.location.href.indexOf('goto_salon') > 0){
     document.getElementById('condestable_salon_div').click();
     $('#condestable_salon').click();
   }else if(window.location.href.indexOf('goto_studio') > 0){
     document.getElementById('condestable_studio_div').click();
     $('#condestable_studio').click();
   }else if(window.location.href.indexOf('goto_bedroom') > 0){
     document.getElementById('condestable_bedroom_div').click();
     $('#condestable_bedroom').click();
   }else if(window.location.href.indexOf('goto_dinningroom') > 0){
     document.getElementById('condestable_dinningroom_div').click();
     $('#condestable_dinningroom').click();
   }else if(window.location.href.indexOf('goto_wine') > 0){
     document.getElementById('condestable_wine_div').click();
     $('#condestable_wine').click();
   }else if(window.location.href.indexOf('goto_assistant') > 0){
     document.getElementById('condestable_assistant_div').click();
     $('#condestable_assistant').click();
   }else{
    //document.getElementById('condestable_dinningroom_div').click();
     $('#condestable_dinningroom').click();
   }

   // set right language
   if(window.location.href.indexOf('/es/') > 0 || window.location.href.indexOf('/es') > 0){
    $('#flag_selector').addClass('flag-icon-es');
   }else if (window.location.href.indexOf('/en/') > 0 || window.location.href.indexOf('/en')  > 0){
    $('#flag_selector').addClass('flag-icon-gb');
   }
});

 // end document ready

/*
**********************************************************
* OPAQUE NAVBAR SCRIPT
**********************************************************
*/

// Toggle tranparent navbar when the user scrolls the page

$(window).scroll(function() {
    if($(this).scrollTop() > 50)  /*height in pixels when the navbar becomes non opaque*/ 
    {
        $('.opaque-navbar').addClass('opaque');
        $('nav').addClass('shrink');
    } else {
        $('.opaque-navbar').removeClass('opaque');
        $('nav').removeClass('shrink');
    }
});


/*
**********************************************************
* AJAX SEND MAIL TEST
**********************************************************
*/

function sendCustomerMail(){

  $.ajax({
       type: "POST",
       url: 'Home/sendCustomerMail',
       data: {data :  $("#customer_contact").serialize() }, // serializes the form's elements.
       dataType: 'text',
       beforeSend : function(){
        $('#send_button').button('loading');
       },
       success: function(data)
       {
          $('#send_button').css({"background-color": "green"});
          $('#send_button').text('Thanks ! ');
       },
       error: function(data)
       {
          $('#send_button').css({"background-color": "red"});
          $('#send_button').html('Error !!');
          console.log('Somethign was wrong , please try again.: '+ data);
       },
       complete : function (){

       }
     });
}

function sendPartnerMail(){

  $.ajax({
       type: "POST",
       url: 'Home/sendPartnerMail',
       data: {data :  $("#partner_contact").serialize() }, // serializes the form's elements.
       dataType: 'text',
       beforeSend : function(){
        $('#send_button_partner').button('loading');
       },
       success: function(data)
       {
          $('#send_button_partner').css({"background-color": "green"});
          $('#send_button_partner').text('Will contact soon, thanks ! ');
       },
       error: function(data)
       {

          $('#send_button_partner').css({"background-color": "red"});
          $('#send_button_partner').html('Error !!');
          console.log('Somethign was wrong , please try again.: '+ data);

       },
       complete : function (){

       }
     });

}

function sendIWannaMail(){

  $.ajax({
       type: "POST",
       url: 'Home/sendIWannaMail',
       data: {data :  $("#i_wanna_form").serialize() }, // serializes the form's elements.
       dataType: 'text',
       beforeSend : function(){
        $('#send_button_iwanna').button('loading');
       },
       success: function(data)
       {
          $('#send_button_iwanna').css({"background-color": "green"});
          $('#send_button_iwanna').text('Will contact soon, thanks ! ');
       },
       error: function(data)
       {

          $('#send_button_iwanna').css({"background-color": "red"});
          $('#send_button_iwanna').html('Error !!');
          console.log('Somethign was wrong , please try again.: '+ data);

       },
       complete : function (){

       }
     });

}


